var scope_0 = require('/zeit/74ab1a93/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/zeit/74ab1a93/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a14decd3934fa9532833cac7548a6e2f.js').default;
var scope_2 = require('/zeit/74ab1a93/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a96f71c9beae1d60430c04fb430e28f1.js').default;
var scope_3 = require('/zeit/74ab1a93/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ec1c1ac2a099028b938176331573c83b.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    